import Enum from '@square/dashboard-utilities/utils/enum';
export const LANGUAGE_LOCALES = new Enum(['AU', 'CA', 'ES', 'FR', 'GB', 'IE', 'JP', 'US', 'ca_ES', 'es_CA', 'es_US', 'fr_CA', 'fr_CA']);
export const COUNTRY_CODES = new Enum(['GB', 'US', 'AU', 'CA', 'IE', 'FR', 'ES', 'JP']);